{
  "ancillaries": {
    "loungeCabinBaggage": {
      "extraTitle": "Lounge + Käsimatkatavara -kombo"
    },
    "loungePriority": {
      "extraTitle": "Lounge + Priority -kombo"
    },
    "loungeWifi": {
      "extraTitle": "Lounge + Internet -kombo"
    },
    "wifiMeal": {
      "extraTitle": "Internet + Ateria -kombo"
    }
  },
  "badges": {
    "finnairForBusiness": "Liikematkaetu"
  },
  "services": {
    "loungeCabinBaggage": {
      "state": {
        "modify": {
          "ariaText": "Muokkaa kombovalintaasi",
          "text": "Muokkaa"
        },
        "purchased": {
          "default": "Ei valittuja komboja",
          "plural": "{numberOfItems} komboa lisätty",
          "singular": "1 kombo lisätty"
        },
        "select": {
          "ariaText": "Valitse kombo",
          "text": "Valitse"
        },
        "selection": {
          "default": "Ei valittuja komboja",
          "plural": "{numberOfItems} komboa valittu",
          "singular": "1 kombo valittu"
        },
        "updating": {
          "ariaText": "Vahvistetaan kombovalintoja"
        }
      }
    },
    "loungeWifi": {
      "loungePriority": {
        "state": {
          "modify": {
            "ariaText": "Muokkaa kombovalintaasi",
            "text": "Muokkaa"
          },
          "purchased": {
            "default": "Ei valittuja komboja",
            "plural": "{numberOfItems} komboa lisätty",
            "singular": "1 kombo lisätty"
          },
          "select": {
            "ariaText": "Valitse kombo",
            "text": "Valitse"
          },
          "selection": {
            "default": "Ei valittuja komboja",
            "plural": "{numberOfItems} komboa valittu",
            "singular": "1 kombo valittu"
          },
          "updating": {
            "ariaText": "Vahvistetaan kombovalintoja"
          }
        }
      },
      "loungeWifi": {
        "state": {
          "modify": {
            "ariaText": "Muokkaa kombovalintaasi",
            "text": "Muokkaa"
          },
          "purchased": {
            "default": "Ei valittuja komboja",
            "plural": "{numberOfItems} komboa lisätty",
            "singular": "1 kombo lisätty"
          },
          "select": {
            "ariaText": "Valitse kombo",
            "text": "Valitse"
          },
          "selection": {
            "default": "Ei valittuja komboja",
            "plural": "{numberOfItems} komboa valittu",
            "singular": "1 kombo valittu"
          },
          "updating": {
            "ariaText": "Vahvistetaan kombovalintoja"
          }
        }
      },
      "wifiMeal": {
        "state": {
          "modify": {
            "ariaText": "Muokkaa kombovalintaasi",
            "text": "Muokkaa"
          },
          "purchased": {
            "default": "Ei valittuja komboja",
            "plural": "{numberOfItems} komboa lisätty",
            "singular": "1 kombo lisätty"
          },
          "select": {
            "ariaText": "Valitse kombo",
            "text": "Valitse"
          },
          "selection": {
            "default": "Ei valittuja komboja",
            "plural": "{numberOfItems} komboa valittu",
            "singular": "1 kombo valittu"
          },
          "updating": {
            "ariaText": "Vahvistetaan kombovalintoja"
          }
        }
      }
    }
  },
  "shoppingCart": {
    "closeCart": "Sulje ostoskori"
  }
}
